<template>
  <div class="lv-state-task-links">
    <LvText :h4="labelMd" :h6="labelSm" :bold="labelBold" class="mb-8"> {{ $t(label) }}</LvText>
    <LvTextCard
      v-for="(item, index) in list"
      :key="index"
      class="pa-16 mb-8"
      :class="{ 'bg-white': bgWhite }"
    >
      <template v-slot:content>
        <LvFlexBox noWrap alignItems="center" class="mb-8">
          <StateInputButton
            :value="item.name"
            required
            rules="required"
            placeholder="名稱"
            class="flex-grow-1"
            @input="$_onInput($event, 'name', index)"
            @paste="$_onPaste(index)"
          />
          <IconButton
            color="red"
            tooltipText="刪除"
            icon="icon-delete"
            @click="$emit('delete', index)"
          />
        </LvFlexBox>
        <LvFlexBox noWrap alignItems="center" class="mb-8">
          <StateInputButton
            :value="item.url"
            split
            required
            placeholder="來源連結"
            rules="required|startsWithHttps"
            class="flex-grow-1"
            @input="$_onInput($event, 'url', index)"
            @paste="$_onPaste(index)"
          />
          <IconButton
            icon="icon-link"
            tooltipText="前往"
            :disabled="!item.url"
            @click="$_onGoToUrl(item.url)"
          />
        </LvFlexBox>
        <InputTextareaButton
          :value="item.remark"
          placeholder="備註"
          :minHeight="100"
          @input="$_onInput($event, 'remark', index)"
        />
      </template>
    </LvTextCard>
    <WsTextButton001 noPadding leadingIcon="icon-add" class="mt-4" @click="$emit('add')">
      <LvText h6 bold lightGray>{{ $t('新增') }}</LvText>
    </WsTextButton001>
  </div>
</template>

<script>
import { extend } from 'vee-validate';
import Spare_task from '@/spare/task';

extend('startsWithHttps', {
  validate: value => {
    if (!value) return false;
    return /^https:\/\/./.test(value);
  },
  message: '您所輸入的 URL 是無效連結！',
});

export default {
  props: {
    label: {
      type: String,
      default: '相關資料',
    },
    list: {
      type: Array,
      default: () => [
        {
          module: '',
          name: '',
          url: '',
          remark: '',
        },
      ],
    },
    bgWhite: {
      type: Boolean,
      default: false,
    },
    labelSm: {
      type: Boolean,
      default: false,
    },
    labelMd: {
      type: Boolean,
      default: true,
    },
    labelBold: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      typeRadioItems: Spare_task.typeRadioItems,
      trailingFields: {
        disabled: true,
        rules: 'required',
        required: true,
        placeholder: '連結結尾',
      },
    };
  },
  computed: {
    _currentDomain() {
      return `https://${window.location.hostname}/`;
    },
  },
  methods: {
    $_onInput($event, key, index) {
      this.$emit('input', { value: $event, key, index });
    },
    $_onGoToUrl(url) {
      window.open(url, '_blank');
    },
    $_onPaste(index) {
      this.$emit('paste', index);
    },
  },
};
</script>
